import { InputType } from "../components/sop/inputPanel";

export const formFields = {
  endpoint: "touristintro",
  inputs: [
    {
      name: "full_name",
      label: "Full Name",
      placeholder: "Ankita Chaudhary",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },

    {
      name: "father_name",
      label: "Father Name",
      placeholder: "Vijay Kumar",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "address",
      label: "Address",
      placeholder: "Balachaur,Punjab",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "nationality",
      label: "Nationality",
      placeholder: "Indian",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "passport_number",
      label: "Passport Number",
      placeholder: "J8369854",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "country",
      label: "Applying for which country ?",
      placeholder: "Canada ",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "visa_type",
      label: "For which visa you have applied for ?",
      placeholder: "Tourist visa ",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },

    {
      label: "Any dependents traveling with you ?",
      type: InputType.InputCluster,
      cols: 2,
      fields: [
        {
          name: "name_of_family_member",
          label: "Write name of members travelling with you.",
          placeholder: "John Doe",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "relation",
          label:
            "Write a relation between you and other who is accompanying you.",
          placeholder: "Brother",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
      ],
    },
    {
      name: "starting_date",
      label: "Your journey begins on",
      placeholder: "1 March 2023",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "ending_date",
      label: "Your journey ends on",
      placeholder: "31 March 2023",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "purpose",
      label: "For what purpose you are travelling?",
      placeholder: "Family Visit ",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
  ],
};

export default formFields;
